import { makeRequest } from 'utils/requestLogger';

export default (id, studentIDS) =>
  makeRequest('post', `/api/courses/${id}/remove`, studentIDS);



// WEBPACK FOOTER //
// ./src/app/services/courses/removeStudents.js